import React from "react";
import {Icon, IconButton, InputAdornment, TextField} from "@material-ui/core";

const SearchBarComponent = ({component}) => {
    const {styles: sourceStyles} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};
    return (
        <div>
            <TextField
                variant={styles.variant || "outlined"}
                placeholder={'Search...'}
                size={styles.size || 'medium'}
                fullWidth
                disabled
                InputProps={{
                    endAdornment: (<InputAdornment position={"end"}>
                        <IconButton size={"small"}>
                            <Icon fontSize={"default"}>
                                search
                            </Icon>
                        </IconButton>
                    </InputAdornment>)
                }}
            />
        </div>
    )
};

export default SearchBarComponent;